import api from '@edu-fe/api'

export default {
  name: 'superPaper',

  getList: (start='',days = 3) => api.create(`/super/briefing/list?start=${start}&days=${days}`),
  getInfo: (start='', columnId, days = 3) => {
    return api.create(`/operation/free/page?start=${start}&days=${days}&columnId=${columnId}`)
  }
}
